'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import { useAdyen } from '../../hooks';
import type { AdyenFormProps } from './types';
import '@adyen/adyen-web/styles/adyen.css';
import './AdyenForm.scss';
export function AdyenForm(t0) {
  const $ = _c(16);
  const {
    setAdyenForm,
    setAdyenFormState,
    holderNameError
  } = t0;
  const {
    adyenForm,
    adyenFormState
  } = useAdyen();
  let t1;
  if ($[0] !== adyenForm || $[1] !== adyenFormState || $[2] !== setAdyenForm || $[3] !== setAdyenFormState) {
    t1 = () => {
      setAdyenForm(adyenForm);
      setAdyenFormState(adyenFormState);
    };
    $[0] = adyenForm;
    $[1] = adyenFormState;
    $[2] = setAdyenForm;
    $[3] = setAdyenFormState;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== adyenForm || $[6] !== adyenFormState) {
    t2 = [adyenForm, adyenFormState];
    $[5] = adyenForm;
    $[6] = adyenFormState;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  useEffect(t1, t2);
  let t3;
  let t4;
  if ($[8] !== holderNameError) {
    t3 = () => {
      const input = document.querySelector(".adyen-checkout__card__holderName__input");
      input?.classList.toggle("adyen-checkout__input--error", !!holderNameError);
    };
    t4 = [holderNameError];
    $[8] = holderNameError;
    $[9] = t3;
    $[10] = t4;
  } else {
    t3 = $[9];
    t4 = $[10];
  }
  useEffect(t3, t4);
  let t5;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div id="adyen-card-container" data-cs-mask={true} />;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== holderNameError) {
    t6 = holderNameError && <span className="adyen-form__holder-name-error adyen-checkout-contextual-text--error" data-testid="holder-name-error">{holderNameError}</span>;
    $[12] = holderNameError;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t6) {
    t7 = <div className="adyen-form" data-testid="adyen-form">{t5}{t6}</div>;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  return t7;
}